var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"usertop"},[_c('router-link',{staticClass:"logomid",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("img/logomid.png"),"alt":""}})])],1),_c('h1',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("源石阅读")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }